import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Checkbox,
  styled,
} from "@mui/material";
import { DateRangePicker } from "../inputs";

export interface SidebarListProps {
  filterType?: string;
  options?: {
    id?: number;
    component?: React.ReactElement | undefined;
  }[];
  setChecked?: (filters: any) => void;
  checked?: any;
}
const StyledCheckbox = styled(Checkbox)(() => ({
  "& .MuiSvgIcon-root": {
    backgroundColor: "rgba(231, 231, 231, 1)",
  },
}));
const SidebarList = ({
  filterType,
  options,
  setChecked,
  checked,
}: SidebarListProps) => {
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    if (setChecked) {
      setChecked(newChecked);
    }
  };

  return (
    <List
      sx={{ width: "100%", overflow: "hidden" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {filterType === "Date Range" ? (
        <React.Fragment>
          <ListItemText
            primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            primary={"Choose Date Range"}
          />
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={(newDate) => setStartDate(newDate)}
            onEndDateChange={(newDate) => setEndDate(newDate)}
          />
        </React.Fragment>
      ) : filterType === "Input" ? (
        <ListItem style={{ display: "flex", flexDirection: "column" }}>
          {options &&
            options.map(() => {
              return (
                <Stack m={1} width="100%">
                  {/* <SelectInput
                    fullWidth
                    placeholder={option.placeholder}
                    options={[]}
                  /> */}
                  {/* <MultipleInput /> */}
                </Stack>
              );
            })}
        </ListItem>
      ) : (
        <React.Fragment>
          <List
            component="div"
            disablePadding
            sx={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              height: "190px",
              width: "300px",
            }}
          >
            {options &&
              options.map((option: any) => {
                return (
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <StyledCheckbox
                        name={option.label}
                        edge="start"
                        checked={checked.indexOf(option.label) !== -1}
                        color={"primary"}
                        onClick={handleToggle(option.label)}
                      />
                    </ListItemIcon>
                    <ListItemText id={option.label} primary={option.label} />
                  </ListItem>
                );
              })}
          </List>
        </React.Fragment>
      )}
    </List>
  );
};
export default SidebarList;
